import {Pipe} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';


@Pipe({name: 'DateFormat'})
export class DateFormatPipe extends TranslatePipe {

  constructor(
    private cookieService: CookieService,
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef
  ) {
    super(translateService, changeDetectorRef);
  }

  transform(value: string, timeFormat?: string) {
    if (typeof value !== 'undefined' && value !== null && value !== '') {
      let dateFormat = this.getDateFormat();
      dateFormat = timeFormat ? dateFormat + ' ' + timeFormat : dateFormat;
      return moment(value).format(dateFormat);
    }
    return '';
  }

  public getDateFormat() {
    const dateFormat = this.cookieService.get('userDateFormat');
    return dateFormat ? dateFormat : 'YYYY-MM-DD';
  }
}
